import type { DelegationSessionResponse } from '@1po/1po-bff-fe-spec/generated/delegation/response/DelegationSessionResponse';
import { DelegationBuyer } from '@1po/1po-bff-fe-spec/generated/delegation/response/model/DelegationBuyer';
import { DelegationSeller } from '@1po/1po-bff-fe-spec/generated/delegation/response/model/DelegationSeller';

import { APP_NAMESPACE } from 'app/App.constants';
import { SEARCH_STATUS } from 'utils';

export const DELEGATION_SESSION_NAMESPACE = `${APP_NAMESPACE}/DELEGATION_SESSION`;
const DELEGATION_RESPONSE_NAMESPACE = `${APP_NAMESPACE}/DELEGATION`;

export const CONNECT_DELEGATION_SESSION_REQUEST = `${DELEGATION_SESSION_NAMESPACE}/CONNECT_REQUEST`;
export const DISCONNECT_DELEGATION_SESSION_REQUEST = `${DELEGATION_SESSION_NAMESPACE}/DISCONNECT_REQUEST`;
export const EXTEND_DELEGATION_SESSION_REQUEST = `${DELEGATION_SESSION_NAMESPACE}/EXTEND_REQUEST`;
export const GET_ACTIVE_DELEGATION_SESSION_REQUEST = `${DELEGATION_SESSION_NAMESPACE}/GET_ACTIVE_REQUEST`;
export const GET_POSSIBLE_SELLERS_TO_DELEGATE = `${DELEGATION_SESSION_NAMESPACE}/GET_POSSIBLE_SELLERS_TO_DELEGATE`;
export const GET_DELEGATION_SELLER = `${DELEGATION_SESSION_NAMESPACE}/GET_DELEGATION_SELLER`;
export const CANCEL_CURRENT_DELEGATION_SELLER = `${DELEGATION_SESSION_NAMESPACE}/CANCEL_CURRENT_DELEGATION_SELLER`;
export const GET_POSSIBLE_BUYERS_TO_DELEGATE = `${DELEGATION_SESSION_NAMESPACE}/GET_POSSIBLE_BUYERS_TO_DELEGATE`;
export const RESET_DELEGATION_SESSION = `${DELEGATION_SESSION_NAMESPACE}/RESET_DELEGATION_SESSION`;

export const CONNECT_DELEGATION_SESSION_RESPONSE = `${DELEGATION_RESPONSE_NAMESPACE}/CONNECT_DELEGATION_SESSION_RESPONSE`;
export const DISCONNECT_DELEGATION_SESSION_RESPONSE = `${DELEGATION_RESPONSE_NAMESPACE}/DISCONNECT_DELEGATION_SESSION_RESPONSE`;
export const EXTEND_DELEGATION_SESSION_RESPONSE = `${DELEGATION_RESPONSE_NAMESPACE}/EXTEND_DELEGATION_SESSION_RESPONSE`;
export const GET_ACTIVE_DELEGATION_SESSION_RESPONSE = `${DELEGATION_RESPONSE_NAMESPACE}/GET_ACTIVE_DELEGATION_SESSION_RESPONSE`;
export const GET_POSSIBLE_SELLERS_TO_DELEGATE_RESPONSE = `${DELEGATION_RESPONSE_NAMESPACE}/GET_POSSIBLE_SELLERS_TO_DELEGATE_RESPONSE`;
export const GET_DELEGATION_SELLER_RESPONSE = `${DELEGATION_RESPONSE_NAMESPACE}/GET_DELEGATION_SELLER_RESPONSE`;
export const GET_POSSIBLE_BUYERS_TO_DELEGATE_RESPONSE = `${DELEGATION_RESPONSE_NAMESPACE}/GET_POSSIBLE_BUYERS_TO_DELEGATE_RESPONSE`;
export const DELEGATION_SESSION_UPDATED_EVENT = `${DELEGATION_RESPONSE_NAMESPACE}/DELEGATION_SESSION_UPDATED_EVENT`;
export const DELEGATION_SESSION_ERROR = `${DELEGATION_RESPONSE_NAMESPACE}/DELEGATION_SESSION_ERROR`;

export interface NullableSearchData<T> {
  searchStatus: SEARCH_STATUS | null;
  data: T | null;
}

export interface DelegationSessionState {
  activeSession: NullableSearchData<DelegationSessionResponse>;
  possibleSellers: NullableSearchData<DelegationSeller[]>;
  possibleBuyers: Map<string, NullableSearchData<DelegationBuyer[]>>;
  isConnecting: boolean;
  isDisconnecting: boolean;
  error: string | null;
  sseConnection: EventSource | null;
  heartbeatActive: boolean;
  lastHeartbeatAt: number | null;
}

export type { ConnectDelegationRequest } from '@1po/1po-bff-fe-spec/generated/delegation/request/ConnectDelegationRequest';
export type { ExtendDelegationRequest } from '@1po/1po-bff-fe-spec/generated/delegation/request/ExtendDelegationRequest';
export type { DelegationSessionResponse } from '@1po/1po-bff-fe-spec/generated/delegation/response/DelegationSessionResponse';
